export default "__VITE_ASSET__hAViaQFu__"